import { resourceSelectors } from '../../utils/resourceSelectors';

export const [clientsAllIdsSelector, clientsByIdSelector, allClientsSelector] =
  resourceSelectors('clients');
